import {Avatar} from 'antd'
import classNames from 'classnames'
import {SearchGroupIcon} from 'components/AppIcon'
import getLinkToDetail from 'helpers/getLinkToDetail'
import getTitle from 'helpers/getTitle'
import _ from 'lodash'
import Translate from 'modules/local/Translate'
import useTranslate from 'modules/local/useTranslate'
import React, {useContext} from 'react'
import {Link} from 'react-router-dom'
import {getLinkToDetailRow} from 'views/AppLocals/Codi/codiHelpers'
import {AppEntities} from 'views/AppLocals/enums'
import {NullAsDefault, renderIf} from 'views/Shared'
import {LayoutContext} from '../layouts/Default/LayoutContext'
import {WithDetailPopup} from '../WithDetailPopup'
import {BibleBookFillSvg} from "../Svgs/BibleBookSvg";

const spliter = '__MENTION__'

function toBase64(text) {
  return Buffer.from(text).toString('base64')
}

function fromBase64(text, encoding = 'utf8') {
  return Buffer.from(text, 'base64').toString(encoding)
}

export const encryptMentionTitle = (
  title,
  params = {
    prefix: undefined,
    connector: undefined,
  }
) => {
  const { prefix, connector = spliter } = params ?? {}
  return [prefix ? toBase64(prefix) : '', toBase64(title)].join(connector)
}

export const decryptMentionTitle = (
  name,
  params = {
    connector: undefined,
  }
) => {
  const { connector = spliter } = params ?? {}
  const array = String(name).split(connector)
  return array.map((item) => fromBase64(item))
}

export const mark_as_mention = (text, params) => {
  const { index = 0, owner_id, owner_type, ...rest } = params ?? {}
  const string = String(text ?? '')
  if (_.isEmpty(string)) return string
  return `[${string}${`(${index + 1})`}]`
}

export const MentionSuggestionItem = ({
    id,
    type,
    name,
    avatar,
    onClick,
    showAvatar = true,
    className,
}) => {
  const t = useTranslate()

  return (
    <div
      key={id}
      onClick={onClick}
      style={{ padding: '5px 12px' }}
      className={classNames(
          "flex items-center gap-2 truncate text-color-000 hover:text-primary hover:background-100 cursor-pointer",
          className
      )}>
      {!!showAvatar && (
        <Avatar
          size={30}
          src={avatar}
          className="flex flex-center background-200"
          icon={
            <SearchGroupIcon
              size={14}
              type={type}
              className="text-color-400"
            />
          }
        />
      )}
      <div className="flex flex-col flex-1 truncate">
        <span className="font-medium text-sm leading-tight truncate">
          {name}
        </span>
        {renderIf(
          type,
          <span className="capitalize font-medium text-2xs text-green-600 italic">
            {t(type)}
          </span>
        )}
      </div>
    </div>
  )
}

export const renderMention =
  ({ onClick = NullAsDefault } = {}) =>
  (item, index) => {
    const {
      id,
      name,
      type,
      label,
      avatar,
      fixed = false,
      onItemClick = NullAsDefault,
    } = item ?? {}
    if (fixed) {
      return (
        <MentionSuggestionItem
          key={index}
          showAvatar={false}
          onClick={() => {
            onItemClick(item?.value)
          }}
          name={
            <Translate>
              {(t) => (
                <span className="flex items-center gap-2 px-1 py-2">
                  <BibleBookFillSvg size={19} className="text-blue-400"/>
                  <span className="text-sm text-blue-600 italic">{t('insert content codi')}</span>
                </span>
              )}
            </Translate>
          }
        />
      )
    }
    return (
      <MentionSuggestionItem
        key={index}
        title={label}
        selectedkey={id}
        {...{
          id,
          name,
          type,
          avatar,
        }}
        onClick={() => {
          onClick({ id, type, name })
        }}
      />
    )
  }

const MusicDescription = ({ item }) => {
  const t = useTranslate()
  const { description } = item ?? {}
  const music_types = Array.from(item?.music_types ?? [])
  const music_authors = Array.from(item?.music_authors ?? [])
  return (
    <div className="flex flex-col gap-2">
      <div className="flex items-center gap-3">
        <span className="text-xs text-color-500 italic">{`${t(
          'music types'
        )} : `}</span>
        {music_types.map((e, i) => (
          <span
            key={i}
            style={{ padding: '2px 8px' }}
            className="w-fit text-2xs font-medium bg-primary-50 text-primary italic rounded-full">
            {getTitle(e)}
          </span>
        ))}
      </div>
      <div className="flex-1 items-baseline gap-1">
        <span className="text-xs text-color-500 italic">{`${t(
          'author'
        )} : `}</span>
        {music_authors.map((e, i, array) => (
          <span
            key={i}
            className="font-bold text-xs text-color-100 italic">
            {e?.fullname} {i < array.length - 1 && ' - '}
          </span>
        ))}
      </div>
      {renderIf(
        description,
        <div className="text-xs text-color-300 italic">{description}</div>
      )}
    </div>
  )
}

export const Mention = ({ prefix, children, mentions }) => {
  const { isSm } = useContext(LayoutContext)
  const [type, id, name] = children.split(':')
  const title = decodeURI(name);
  const mention = _.find(
    mentions,
    (item) =>
      item?.owner_type === type &&
      (item?.owner_id === id ||
        item?.idname === id ||
        item?.owner?.username === id),
    {}
  )

  const { owner = {}} = mention ?? {}

  const OwnerLink = owner ? Link : 'div'

  if (type === "keyword") {
    if (isSm) {
      return (
        <OwnerLink
          to={`/t/${id}`}
          className={classNames('text-sm text-primary font-medium')}>
          {title}
        </OwnerLink>
      )
    }
    return (
      <WithDetailPopup item={{_type: 'keyword', id, title}}>
        <span
          className={classNames(
            'inline text-sm text-primary font-medium cursor-pointer'
          )}>
          {title}
        </span>
      </WithDetailPopup>
    )
  }

  if (type === AppEntities.CODI_DOCUMENT) {
    // const [__, title] = decryptMentionTitle(name) ?? [,]
    // const title = decodeURI(name);
    if (isSm) {
      return (
        <OwnerLink
          to={getLinkToDetail(owner)}
          className={classNames('text-sm text-primary font-medium')}>
          {title ? title : getTitle(owner)}
        </OwnerLink>
      )
    }
    return (
      <WithDetailPopup item={owner}>
        <span
          className={classNames(
            'inline text-sm text-primary font-medium cursor-pointer'
          )}>
          {title ? title : getTitle(owner)}
        </span>
      </WithDetailPopup>
    )
  }

  if (type === AppEntities.CODI_DOCUMENT_ROW) {
    // const [__, title] = decryptMentionTitle(name) ?? [,]
    // const title = decodeURI(name);
    if (_.isEmpty(mention)) return null;
    if (isSm) {
      return (
        <OwnerLink to={getLinkToDetailRow(owner)}>
          {title ? (
            <span className="font-medium text-primary italic">{title}</span>
          ) : (
            getTitle(mention)
          )}
        </OwnerLink>
      )
    }
    return (
      <WithDetailPopup
        item={{
          ...owner,
          title: getTitle(mention),
          to: getLinkToDetailRow(owner),
        }}>
        <span className="inline cursor-pointer">
          {title ? (
            <span className="font-medium text-primary italic">{title}</span>
          ) : (
            getTitle(mention)
          )}
        </span>
      </WithDetailPopup>
    )
  }

  if (!mention) {
    return children
  }

  return (
    <WithDetailPopup
      item={{
        ...(owner ?? {}),
        description:
          type === AppEntities.MUSIC ? (
            <MusicDescription item={owner} />
          ) : (
            owner?.description
          ),
      }}>
      <span className="color-primary font-medium cursor-pointer">
        {title}
      </span>
    </WithDetailPopup>
  )
}
